module.exports = __webpack_public_path__ + "media/images/android-chrome-192-0e1f6a7b7c993fa242e77d27b58b611f.png";